import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Organisation from 'components/Organisations/Organisation';
import List from 'components/Organisations/List';

class Organisations extends React.Component {
  render = () => {
    const { match } = this.props;

    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
          <Route path={`${match.url}/:orgId`} component={Organisation}/>
        </Switch>
      </div>
    );
  };
}

export default Organisations;



// WEBPACK FOOTER //
// ./src/components/Organisations/index.js